import { UserModel } from '@app/domain/UserModel';
import { persistUser, readTokenValid, readUser } from '@app/services/localStorage.service';
import { createAction, createSlice, PrepareAction } from '@reduxjs/toolkit';

export interface UserState {
  user: UserModel | null;
  tokenValid: boolean | null;
}

const initialState: UserState = {
  user: readUser(),
  tokenValid: readTokenValid(),
};

export const setUser = createAction<PrepareAction<UserModel>>('user/setUser', (newUser) => {
  persistUser(newUser);

  return {
    payload: newUser,
  };
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
  },
});

export default userSlice.reducer;
